import { Translatable } from '@icc/shared/helpers';

/** Rodzaj moskitiery */
export class MosquitoScreenType {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do druku */
    printCode: string;
    /** Nazwa */
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Opis */
    description: string;
    /** Zdjęcie */
    img: string;
    /** Maksymalna szerokość */
    maxWidth: number;
    /** Maksymalna wysokość */
    maxHeight: number;
    /** Przypisane typy produktów */
    shutterTypes: number[];
    /** Id zestawu grup kolorów */
    colorGroupSetId: number;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
    /** Kolejność */
    order: number;
}